import React from 'react';
import './Disposablebox.css';



const Disposablebox = () => {
    return (
        <div className="mold-container">
            <h2 className="heading">Disha Disposable Food Box Injection Production</h2>
            <p><strong>Case for Reference: The cycle time of each machine
                 may vary, you could share your
                 target production capacity on how many piece per hour to us!</strong></p>
            <div className="details-grid">
                <div className="left-column">
                    <p><strong>Machine Model</strong> </p>
                    <p><strong>Product</strong> </p>
                    <p><strong>Mold Cavity</strong> </p>
                    <p><strong>Thickness</strong></p>
                    <p><strong>Weight</strong></p>
                    <p><strong>Material</strong></p>
                </div>
                <div className="right-column">
                    <p>KF390-S8</p>
                    <p>750ml Square Disposable Food Box</p>
                    <p>	4 Cavities</p>
                    <p>	0.37mm</p>
                    <p>	13g</p>
                    <p>PP</p>
                </div>
            </div>
        </div>
    );
};

export default Disposablebox;
